import { makeRequest } from 'utils/requestLogger';

export default (commentID) =>
  makeRequest('delete', `/api/comments/${commentID}/delete-comment`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/comment/deleteComment.js